import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Layout from "../components/Layout";
import Card from "../components/Card";

const SupplierDetails = () => {
  const { id } = useParams();
  const [medicines, setMedicines] = useState([]);
  const [filteredMedicines, setFilteredMedicines] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const API_BASE_URL = 'https://api.tenarx.net';
  useEffect(() => {
    const fetchMedicines = async () => {
      setLoading(true);
      setError(null);
      try {
        const token = localStorage.getItem("userToken");
        const res = await fetch(`${API_BASE_URL}/api/imports/my/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await res.json();
        if (res.ok && data.success) {
          setMedicines(data.data || []);
          setFilteredMedicines(data.data || []);
        } else {
          setError(data.message || "Failed to fetch medicines");
        }
      } catch (err) {
        setError("Failed to fetch medicines");
      } finally {
        setLoading(false);
      }
    };
    fetchMedicines();
  }, [id]);

  useEffect(() => {
    if (!searchTerm) {
      setFilteredMedicines(medicines);
    } else {
      setFilteredMedicines(
        medicines.filter((m) =>
          m.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          m.content.toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    }
  }, [searchTerm, medicines]);

  return (
    <Layout>
      <div className="max-w-5xl mx-auto py-8">
        <Card>
          <h2 className="text-xl font-bold mb-4">Supplier Medicines</h2>
          <div className="mb-4 flex justify-end">
            <input
              type="text"
              placeholder="Search medicines..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="px-3 py-2 border border-gray-300 rounded-md w-full max-w-xs"
            />
          </div>
          {loading ? (
            <div className="text-gray-500">Loading...</div>
          ) : error ? (
            <div className="text-red-500">{error}</div>
          ) : filteredMedicines.length === 0 ? (
            <div className="text-gray-500">No medicines found for this supplier.</div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm text-left text-gray-500">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                  <tr>
                    <th className="px-6 py-3">Name</th>
                    <th className="px-6 py-3">Content</th>
                    <th className="px-6 py-3">Amount</th>
                    <th className="px-6 py-3">Country</th>
                    <th className="px-6 py-3">Type</th>
                    <th className="px-6 py-3">Expire Date</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredMedicines.map((m, idx) => (
                    <tr key={m._id || idx} className="bg-white border-b">
                      <td className="px-6 py-4">{m.name}</td>
                      <td className="px-6 py-4">{m.content}</td>
                      <td className="px-6 py-4">{m.amountAvailable} {m.amountAvailableUnit}</td>
                      <td className="px-6 py-4">{m.country}</td>
                      <td className="px-6 py-4">{m.type}</td>
                      <td className="px-6 py-4">{new Date(m.expireDate).toLocaleDateString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </Card>
      </div>
    </Layout>
  );
};

export default SupplierDetails; 